module.exports = __webpack_public_path__ + "img/wz-5-6.84193a56.png";